import React from 'react';
import { alpha, useTheme } from '@mui/material/styles';
import { Box, Grid } from '@mui/material';
import { SimTypography } from 'components/SimTypography';

import BGFEParentEd from 'assets/images/BGFEParentEd.png';

const FeaturesParentEd = () => {
	const theme = useTheme();

	const RightSide = () => (
		<Box>
			<Box>
				<SimTypography variant={'h4'} sx={{ fontWeight: 700 }} gutterBottom>
					SimSouls{' '}
					<Box component='span' color={theme.palette.secondary.mainGreen}>
						{' '}
						ParentEd{' '}
					</Box>
				</SimTypography>

				<SimTypography color={theme.palette.secondary.mainGreen} variant={'h6'}>
					No neurodiverse child be left behind because they cannot afford healthcare.
				</SimTypography>

				<Box marginTop={4}>
					<SimTypography color='text.secondary' align='left' variant='h6'>
						Research shows that children make better progress when families are strongly engaged and
						involved. We recognize many parents cannot afford to take their children to a clinic. CARES, a
						ParentEd program, offers caregivers free educational and emotional support resources.
					</SimTypography>
				</Box>

				<Box marginTop={2}>
					<SimTypography color='text.secondary' align='left' variant='h6'>
						<Box component='span' color={theme.palette.primary.main}>
							{' '}
							Join our free community sessions, workshops, and events{' '}
						</Box>{' '}
						to connect with fellow parents, to learn quintessential skills to raise children with special
						needs, and to help children learn social skills in a safe & naturalistic environment.
					</SimTypography>
				</Box>
			</Box>
		</Box>
	);
	return (
		<Box>
			<Box>
				<Grid container spacing={0} backgroundColor={'transparent'}>
					<Grid item xs={12} sm={12}>
						<Box display={'flex'} flexDirection={'column'}>
							<Box
								sx={{
									backgroundImage: `url(${BGFEParentEd})`,
									backgroundRepeat: 'no-repeat',
									backgroundPosition: 'left',
									backgroundSize: 'contain'
								}}>
								<Box
									width={1}
									display={'flex'}
									flexDirection={'row'}
									justifyContent={'right'}
									sx={{
										backgroundImage: {
											xs: `linear-gradient(270deg, ${theme.palette.background.default} , ${alpha(
												theme.palette.background.default,
												0.7
											)} 100%)`,
											sm: `linear-gradient(270deg, ${theme.palette.background.default} 35%, transparent 65%)`
										},

										backgroundRepeat: 'no-repeat',
										backgroundPosition: 'right',
										backgroundSize: 'contain'
									}}>
									<Box
										width={{ sm: '50%', lg: '50%' }}
										paddingLeft={4}
										paddingRight={{ xs: 3, lg: 32 }}
										paddingY={4}>
										<RightSide />
									</Box>
								</Box>
							</Box>
						</Box>
					</Grid>
				</Grid>
			</Box>
		</Box>
	);
};

export { FeaturesParentEd };
